import { ListComponentItemType } from "@/types"
import EventsEditorComponent from "./events-editor-component"
import TabsComponent from "./tabs-component"
import UserListComponent from "./user-list-component"

const StaffComponent = () => {

    const tabLabels = ["Members", "Events Editor", "Events List"]

    return (
        <>
            <TabsComponent variant="enclosed" labels={tabLabels}>
                <UserListComponent itemType={ListComponentItemType.UserInfo} />
                <EventsEditorComponent />
                <UserListComponent itemType={ListComponentItemType.EventInfo} />
            </TabsComponent>
        </>
    )
}

export default StaffComponent